import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import "./avatar.scss";

const Avatar = ({ colour, className, initials, text, icon, ...props }) => {
  return (
    <div className={classnames("avatar", `avatar--${colour}`, className)} {...props}>
      <div className="avatar__inner">
        {!!initials && <div className="avatar__initials">{initials}</div>}
        {!!icon && <div className="avatar__icon">{icon()}</div>}
        {!!text && <div className="avatar__text">{text}</div>}
      </div>
    </div>
  );
};

Avatar.propTypes = {
  colour: PropTypes.oneOf(["red", "black", "grey"]),
  initials: PropTypes.string,
  text: PropTypes.string,
  icon: PropTypes.func,
  className: PropTypes.string,
};

export default Avatar;
